import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHandling } from "./baseQuery";
import type { CurrentUser } from "../types/auth";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: baseQueryWithAuthHandling,
  endpoints: (builder) => ({
    getCurrentUser: builder.query<CurrentUser, void>({
      query: () => "/auth",
      transformResponse: (raw: { status: string; data: CurrentUser }) =>
        raw.data,
    }),
  }),
});

export const { useGetCurrentUserQuery } = authApi;
